import { render, staticRenderFns } from "./zhengce.vue?vue&type=template&id=65117287&scoped=true"
import script from "./zhengce.vue?vue&type=script&lang=js"
export * from "./zhengce.vue?vue&type=script&lang=js"
import style0 from "./zhengce.vue?vue&type=style&index=0&id=65117287&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65117287",
  null
  
)

export default component.exports